export default __webpack_public_path__ + "static/media/team-profile.fb639477.png";